import React from "react";
import Container from "@material-ui/core/Container";
import TranslatorSignUp from "../../components/Authentication/TranslatorSignUp";

export default function TranslatorSignUpPage() {
  return (
    <Container>
      <TranslatorSignUp />
    </Container>
  );
}
